function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.058824%,1.176471%,72.549021%)",
      fillOpacity: 1
    },
    d: "M 22.5 11.25 L 22.5 0 L 7.5 0 L 7.5 11.25 L 0 11.25 L 0 24.375 L 30 24.375 L 30 11.25 Z M 13.125 22.5 L 1.875 22.5 L 1.875 13.125 L 5.625 13.125 L 5.625 15 L 9.375 15 L 9.375 13.125 L 13.125 13.125 Z M 9.375 11.25 L 9.375 1.875 L 13.125 1.875 L 13.125 3.75 L 16.875 3.75 L 16.875 1.875 L 20.625 1.875 L 20.625 11.25 Z M 28.125 22.5 L 16.875 22.5 L 16.875 13.125 L 20.625 13.125 L 20.625 15 L 24.375 15 L 24.375 13.125 L 28.125 13.125 Z M 28.125 22.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(87.058824%,1.176471%,72.549021%)",
      fillOpacity: 1
    },
    d: "M 0 30 L 5.625 30 L 5.625 28.125 L 24.375 28.125 L 24.375 30 L 30 30 L 30 26.25 L 0 26.25 Z M 0 30 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/Stock.9cffe3f2eff3cf2c5a0a07eb2cec27d5.svg";
export { ForwardRef as ReactComponent };